module.exports = __webpack_public_path__ + "static/media/singnasium.34d00e01.png";